module.exports = __webpack_public_path__ + "img/Girl_010003.fd3f51e3.png";